import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
import { WorkflowObservableService } from "@app/workflow-common/services/workflow-observable.service";
import { SidebarNavService } from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import { CsToastBoxService } from "@app/services";
var BasicDetailsStepComponent = /** @class */ (function () {
    function BasicDetailsStepComponent(_formBuilder, _workflowHttp, workflowObservableService$, toastBox) {
        this._formBuilder = _formBuilder;
        this._workflowHttp = _workflowHttp;
        this.workflowObservableService$ = workflowObservableService$;
        this.toastBox = toastBox;
        this.workflowData = undefined;
        this.closeFullScreenModal = undefined;
        this.isDraftMode = true;
        this.name = '';
        this.description = '';
        this.workflowId = 0;
        this.isSaving = false;
        this.currentStep = 'basic_details';
    }
    BasicDetailsStepComponent.prototype.ngOnInit = function () {
        if (this.workflowData) {
            this.name = this.workflowData['name'];
            this.description = this.workflowData['description'];
            this.workflowId = this.workflowData['id'];
        }
        this.form = this._formBuilder.group({
            id: new FormControl(this.workflowId),
            name: new FormControl(this.name, [Validators.required]),
            description: new FormControl(this.description)
        });
    };
    BasicDetailsStepComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        this._workflowHttp.saveCustomAutomation(this.screenName, this.settingsTypeId, this.objectName, { customAutomationSave: this.form.value }).subscribe({
            next: function (resp) {
                if (resp.hasOwnProperty('customAutomationSave')) {
                    var data = resp['customAutomationSave'];
                    _this.workflowObservableService$.setWorkflowData(data);
                    _this.workflowData = data;
                    _this.sidebarNavService.goToNext(_this.currentStep);
                }
                else {
                    _this.toastBox.show(resp['message']);
                    console.error(resp);
                }
            },
            error: function (err) { return console.error(err); }
        });
    };
    return BasicDetailsStepComponent;
}());
export { BasicDetailsStepComponent };
